import type { FUEL_TYPE$options } from '$houdini';
import * as m from '$paraglide/messages';

const gasStationFuelLabel: Record<FUEL_TYPE$options, () => string> = {
	B10: m.gas_station__fuel_label__B10,
	B7: m.gas_station__fuel_label__B7,
	CNG: m.gas_station__fuel_label__CNG,
	E10: m.gas_station__fuel_label__E10,
	E5: m.gas_station__fuel_label__E5,
	E5_98: m.gas_station__fuel_label__E5_98,
	E85: m.gas_station__fuel_label__E85,
	LPG: m.gas_station__fuel_label__LPG,
	H2: m.gas_station__fuel_label__H2,
};

export function gasStationFuel(type: FUEL_TYPE$options): string {
	return gasStationFuelLabel[type]();
}
